import { ChangeDetectorRef, Component, EventEmitter, HostListener, Input, OnInit, Output, ViewChild } from '@angular/core';
import { RegisterPersonNifInfoComponent } from './register-person-nif-info/register-person-nif-info.component';
import { TranslateService } from '@ngx-translate/core';
import { RegisterPersonLastStepComponent } from '../register-person-last-step/register-person-last-step.component';
import { RegisterFileComponent } from '../register-file/register-file.component';
import { RegisterPersonEmailComponent } from './register-person-email/register-person-email.component';
import { countryPrefix } from 'src/app/pages/my-profile/phone-prefix';
import { ProfileService } from 'src/app/services/profile.service';
import { LocalizeRouterService } from '@gilsdav/ngx-translate-router';
import { NavController } from '@ionic/angular';
import { Profile, RegisterPersonMainData } from 'src/app/shared/models/register.models';
import { ActionSheetService } from '../../action-sheet/action-sheet.service';
import { ToastService } from '../../toast/toast.service';
import { ModalService } from '../../modal/modal.service';
import { Storage } from '@ionic/storage';

@Component({
  selector: 'fun-register-person',
  templateUrl: './register-person.component.html',
  styleUrls: ['./register-person.component.scss']
})
export class RegisterPersonComponent implements OnInit {

  @Output() public prevStepEvent = new EventEmitter<any>();
  @Output() public lastStepEvent = new EventEmitter<any>();
  @Output() public prevEvent = new EventEmitter<any>();
  @Output() public nextEvent = new EventEmitter<any>();
  @Output() public changeWayEvent = new EventEmitter<any>();
  @Output() public finishRegisterEvent = new EventEmitter<any>();
  @Output() public phoneNumberEvent = new EventEmitter<any>();
  @Output() public confirmCodeEmailEvent = new EventEmitter<any>();
  @Output() public confirmCodeEvent = new EventEmitter<any>();
  @Output() public confirmPhoneEvent = new EventEmitter<any>();
  @Output() public resendCodeEvent = new EventEmitter<any>();
  @Output() public fullInfoEvent = new EventEmitter<any>();
  @Output() public validateEmailEvent = new EventEmitter<any>();
  @Output() public changeEmailEvent = new EventEmitter<any>();
  @Output() public getAddressInfoEvent = new EventEmitter<any>();
  @Output() public downloadAppEvent = new EventEmitter<any>();
  @Output() public generateProfileEvent = new EventEmitter<any>();
  @Output() public updateInfoEvent = new EventEmitter<any>();
  @Output() public emitDocumentEvent = new EventEmitter<any>();
  @Output() public setDocumentsEvent = new EventEmitter<any>();
  @Output() public emitDocumentsEvent = new EventEmitter<any>();
  @Output() public accreditationChecksEvent = new EventEmitter<any>();
  @Output() public bankDocumentEvent = new EventEmitter<any>();
  @Output() public acceptLwTermsEvent = new EventEmitter<any>();
  @Output() public finishEvent = new EventEmitter<any>();
  @Output() public signaturitAccreditEvent = new EventEmitter<any>();
  @Output() public continueInvestEvent = new EventEmitter<any>();
  @Output() public otherMomentEventEvent = new EventEmitter<any>();
  @Output() public updateDocNumberEvent = new EventEmitter<any>();
  @Output() public signaturitSignedEvent = new EventEmitter<any>();
  @Output() public checkRefCodeEvent = new EventEmitter<any>();
  @Output() public removeModalEvent = new EventEmitter<any>();

  @Input() registerStep: any;
  @Input() isMobileApp: any;
  @Input() info: RegisterPersonMainData = {};
  @Input() list: any = {};
  @Input() profile: Profile;
  @Input() towns: any;
  @Input() editM: boolean;
  @Input() specificFileSteps: any;
  @Input() onlyAccredit: any;
  @Input() updateSpecificDocument: any;
  @Input() addSpecificNie: boolean;

  @ViewChild('registerPersonAccredited', { static: false }) registerPersonAccredited: RegisterPersonLastStepComponent;
  @ViewChild('registerPersonFile', { static: false }) registerPersonFile: RegisterFileComponent;
  @ViewChild('registerPersonEmail', { static: false }) registerPersonEmail: RegisterPersonEmailComponent;

  public step: number;

  public moneyOutInfo;
  public skeletonActive = false;
  public sendXHR;
  public selectIsOpen = false;

  public acceptConditions: boolean;
  lastStep: boolean;
  phoneNumber: any;
  isRegister: boolean;
  secondBtn: string;

  public userInfo: any = {};

  text = this.translate.instant('register.identity.txt');
  textIdOk = this.translate.instant('register.identity.txt_id_ok');
  btnList = [{
    type: 'primaryDark',
    index: 1,
    title: this.translate.instant('register.messages.continue'),
  }];
  btnListN = [];
  image = 3;
  idDocumentIndex: number;
  messageIndex: number;
  phoneIndex: number;
  codeIndex: number;
  emailIndex: number;
  emailCodeindex: number;
  nationalityIndex: number;
  addressIndex: number;
  downloadIndex: number;
  generateProfileIndex: number;
  fileIndex: number;
  accreditIndex: number;
  civilStatusindex: number;
  investMessageIndex: number;
  investFinishMessageIndex: number;
  mailValidatedIndex: number;
  phoneValidatedIndex: number;
  okInvestMessageIndex: number;
  documentOkFileIndex: number;
  mangopayWalletIndex: number;
  successStepIndex: number;
  documentNieMsgIndex: number;
  verifyEmailIndex: number;
  taxdownIndex: number;

  addressValue: any;
  region: any;
  public wantToDownload = true;

  public loading: boolean;

  countDown: string;
  isCountDowndEnd = false;
  resended = false;
  activatedCountDoun = false;
  cStatus: number;
  personalId: string;

  plusLastStep = 1;
  device: string;
  currentLang: string;
  mailChanged = false;

  textM = this.translate.instant('register.messages.no_data_1');
  textNie = this.translate.instant('register.messages.nie_info_msg');
  imageNie = 3;
  imageMailV = 10;
  imagePhoneV = 11;
  textF = this.translate.instant('register.messages.no_data_2');
  textMailV = this.translate.instant('register.messages.congratulations_1');
  textPhoneV = this.translate.instant('register.messages.congratulations_2');
  textI = this.translate.instant('register.messages.congratulations_3');
  imageM = 3;
  btnListM = [{
    type: 'primaryDark',
    index: 1,
    title: this.translate.instant('register.messages.continue'),
  }];

  btnWrongDoc = [];

  documentCanBack: boolean;
  percent: number;
  stepNumber: number;
  refCode: string;
  mangopayTerms = false;
  emailPage = 'email';
  privacyTxt: string;
  termsTxt: string;
  hasPrivacyText = false;
  hasTermsTxt = false;
  hasToacceptMpTerms = false;

  textAcceptMail = this.translate.instant('register.validate_mail_msg');
  btnListAcceptMail = [{
    type: 'primaryDark',
    index: 1,
    title: this.translate.instant('register.messages.continue'),
  }];
  imageAcceptMail = 6;

  @HostListener('document:keyup.enter', ['$event']) onKeyupEnterHandler(event: KeyboardEvent) {
    if (this.sendXHR === 'primaryDark') {
      this.next();
    }
  }

  constructor(
    public chdRef: ChangeDetectorRef,
    public actionSheetService: ActionSheetService,
    public translate: TranslateService,
    private profileService: ProfileService,
    private toastService: ToastService,
    private navCtrl: NavController,
    private localize: LocalizeRouterService,
    private modalService: ModalService,
    private storage: Storage
    ) {
    if (this.onlyAccredit && this.onlyAccredit !== undefined) {
      this.lastStep = false;
    } else {
      this.lastStep = true;
    }
   }

  ngOnInit() {
    this.checkSteps();
    this.getPrivacyPolicy();
    //this.getTermsPolicy();
    if (this.profile !== null && this.profile !== undefined) {
      //
      if (this.profile.walletstatus !== null && this.profile.walletstatus !== undefined && this.profile.walletstatus > 0) {
        let msg;
        this.imageM = 4;
        if (this.profile.walletstatus === 5) {
          this.textM = this.translate.instant('register.messages.no_data_4');
          this.btnListM = [{
            type: 'primaryDark',
            index: 3,
            title: this.translate.instant('register.messages.continue'),
          }];
          this.btnWrongDoc.push({
            type: 'primaryDark',
            index: this.profile.walletstatus === 5 ? 3 : 1,
            title: this.translate.instant('register.messages.continue'),
          });
        }
        const wrongDocuments = this.profile.files.filter((item) => item.lwStatus > 2 || item.mpStatus > 3);
        if (wrongDocuments.length > 0) {
          msg = this.translate.instant('MESSAGES.BAD_PROFILE_2');
        } else {
          msg = this.translate.instant('MESSAGES.BAD_PROFILE_2');
        }
        this.textF = this.profile.walletstatus === 5 ? this.translate.instant('register.messages.no_data_4') : `<h2>Perfil incorrecto.</h2><p>${msg}</p>`;
        if (this.profile.walletstatus !== 5) {
          this.btnWrongDoc.push({
            type: 'primaryDark',
            index: 1,
            title: this.translate.instant('register.messages.continue'),
          });
        }
      } else if (this.profile.walletstatus === -1) {
        this.profile.files.forEach(element => {
          if ((element.field === 'ID_CARD_FRONT' || element.field === 'ID_CARD_BACK') && element.mpStatus !== null && (element.mpStatus > 3 || element.lwStatus > 2)) {
            this.textF = `<h2>Perfil incorrecto.</h2><p>${this.translate.instant('MESSAGES.BAD_PROFILE_2')}</p>`;
            this.btnWrongDoc = [
              {
                type: 'primaryDark',
                index: 1,
                title: this.translate.instant('register.messages.continue'),
              }
            ];
          }
        });
      }
      if (this.addSpecificNie) {
        this.specificFileSteps = [{index: 0, name: 'nie_file'}];
      }
    }
    this.chdRef.detectChanges();
  }

  async getPrivacyPolicy() {
    const privacy = this.translate.currentLang === 'es' ? 'privacidad' : 'privacy';
    this.profileService.getText(privacy, this.translate.currentLang).subscribe(value => {
      this.privacyTxt = value.content;
      this.hasPrivacyText = true;
      this.chdRef.detectChanges();
    }, error => {
      this.privacyTxt = '<p>Versión 2.0 - 31 de octubre de 2019</p>\n<br>\n<p>Esta es nuestra Política de Privacidad (en adelante, la “Política”) que es aplicable al tratamiento de datos personales que realizamos en\n          FUNDEEN SPAIN, P.F.P., S.L., (en adelante, “Fundeen”) a través de nuestra página web <a href=\"www.fundeen.com\">www.fundeen.com </a> (en adelante, la “Web”).\n        </p>\n        <p>Fundeen es una plataforma autorizada y supervisada por la Comisión Nacional del Mercado de Valores (en adelante, la “CNMV”)\n          conforme a lo establecido en la Ley 5/2015, de 27 de abril, de fomento a la financiación empresarial,\n          e inscrita con el número 27 en el Registro de Plataformas de Financiación Participativa de la CNMV.</p>\n          <p>Fundeen  pretende  democratizar  la  inversión  en  proyectos  de  energía  renovable  y  hacerla accesible a cualquier ciudadano.</p>\n          <p>En Fundeen  consideramos  imprescindible  proteger  la  privacidad  y  la  seguridad  de  tus  datos personales, tal como describimos en esta Política.</p>\n          <h2>1.\tDATOS DE CONTACTO</h2>\n          <p>FUNDEEN SPAIN, P.F.P., S.L., sociedad española debidamente inscrita en el Registro Mercantil de Ávila al tomo 175, libro 133, folio 1, sección 8ª, hoja AV-6832, inscripción 2ª.</p>\n          <ul>\n            <li>»\tDirección: Plaza de Santa Teresa de Jesús, 14, 1º-1, 05001, Ávila</li>\n            <li>»\tNIF: B-87884896</li>\n            <li>»\tEmail de contacto: <a href=\"href=mailto:privacidad@fundeen.com\">privacidad@fundeen.com</a></li>\n          </ul>\n          <p>En cualquier caso, puedes contactar con nuestro DELEGADO/A DE PROTECCIÓN DE DATOS en la dirección de correo electrónico indicada arriba.</p>\n          <h2>2. NORMATIVA  APLICABLE  Y  PRINCIPIOS  DE  PROTECCIÓN  DE  DATOS PERSONALES</h2>\n          <p>La recogida de datos personales, el tratamiento y su utilización posterior por Fundeen está sujeta al Reglamento UE 2016/671 General de Protección de Datos,\n            de fecha 27 de abril de 2016 (en adelante, por sus siglas “RGPD”), y la Ley Orgánica 3/2018, de 5 de diciembre,\n            de Protección de Datos Personales y garantía de los derechos digitales (en adelante, la “LOPDyGDD”).</p>\n          <p>En Fundeen tratamos tus datos personales con arreglo a los siguientes principios (establecidos en dicha normativa): </p>\n          <ul>\n            <li>»\tTratar los datos con licitud, lealtad y transparencia.</li>\n            <li>»\tTratar los datos de forma limitada a la finalidad por la que fueron recogidos.</li>\n            <li>»\tMinimización de datos: tratar datos adecuados, pertinentes y limitados a lo necesario.</li>\n            <li>»\tExactitud: tratar datos exactos y, cuando es necesario, actualizados.</li>\n            <li>»\tLimitación del plazo de conservación: no conservar datos más del tiempo necesario para los fines requeridos.</li>\n            <li>»\tIntegridad y confidencialidad, garantizando un nivel de seguridad adecuado.</li>\n          </ul>\n          <h2>3. ¿QUÉ BASES JURÍDICAS NOS PERMITEN TRATAR TUS DATOS PERSONALES?</h2>\n          <p>En  Fundeen solo  recogemos  y  tratamos  tus  datos  personales  cuando  se  da  alguna  de  las situaciones expuestas a continuación:</p>\n          <ul>\n            <li>(a) Tenemos tu consentimiento explícito.</li>\n            <li>(b) Es necesario para prestarte nuestros servicios de inversión en proyectos de energía\n              renovable en base al cumplimiento y ejecución de los contratos necesarios.</li>\n            <li>(c) Para dar cumplimiento a nuestros intereses legítimos para fines estadísticos y/o cuando nos consultas o solicitas un servicio.</li>\n            <li>(d)\tEn caso de que debamos cumplir con nuestras obligaciones legales.</li>\n          </ul>\n          <h2>4. ¿PARA QUÉ UTILIZAMOS TUS DATOS PERSONALES?</h2>\n          <p>Fundeen únicamente utiliza tus datos personales para las siguientes finalidades:</p>\n          <ul>\n            <li>» Prestar nuestros servicios consistentes en ayudar y asistir a particulares a poder invertir en proyectos de energías renovables.</li>\n            <li>» Contestar a una solicitud de información y/o comunicación, incluyendo este caso el remitir información solicitada y relevante.</li>\n            <li>» Envío –previa autorización– de comunicaciones comerciales y promocionales por los medios facilitados.</li>\n            <li>» Cumplir con las leyes y normas aplicables. Por ejemplo, cuando necesitamos tratar tus datos para realizar verificaciones\n              en cumplimiento de las normas sobre prevención del blanqueo de capitales y de la financiación del terrorismo.</li>\n            <li>» Realización de estadísticas para conocer el tráfico y utilización de la Web, así como focalizar la información publicitaria de acuerdo con sus intereses. </li>\n            <li>» Tratamiento automático y de información agregada para procurar que la información que te enviamos es acorde a tus intereses.</li>\n          </ul>\n          <h2>5. ¿QUÉ DATOS PERSONALES RECABA FUNDEEN?</h2>\n          <p>Un dato personal es cualquier información alfanumérica, gráfica, fotográfica, acústica o de cualquier otro tipo que pueda ser\n            identificada o vinculada a una persona física concreta.\n          </p>\n          <p>En este sentido, la recogida de datos personales se realizará a través de los formularios presentes en la propia Web o a través de\n              cualquier otro medio de contacto: chat habilitado en la Web, correo electrónico o telefónicamente.\n          </p>\n          <p>Fundeen te informará en todo momento de la cumplimentación de datos obligatorios para el completo funcionamiento de la aplicación y\n            para el cumplimiento de las obligaciones legales. En caso de no facilitarlos, únicamente se podrá navegar por la Web, pero podrás operar.\n          </p>\n          <p>En virtud de lo expuesto, la información de carácter personal que se va a recabar será la siguiente:</p>\n          <ul>\n            <li>\n              <span>» Datos identificativos:</span>\n              <ul>\n                <li>o\tCorreo electrónico</li>\n                <li>o Nombre y apellidos</li>\n                <li>o Fecha de nacimiento</li>\n                <li>o Número de teléfono</li>\n                <li>o Sexo</li>\n                <li>o Nacionalidad</li>\n                <li>o Domicilio fiscal</li>\n                <li>o Documento de identidad: DNI, NIE o Pasaporte</li>\n              </ul>\n            </li>\n            <li>» Datos financieros necesarios o derivados de la ejecución de nuestros servicios.</li>\n            <li>» Datos personales relacionados con sus intereses o preferencias de inversión.</li>\n            <li>» En su caso, datos de actividad en nuestra página para fines estadísticos.</li>\n          </ul>\n          <h2>6. ¿CON QUIÉN COMPARTIMOS TUS DATOS PERSONALES?</h2>\n          <p>Tus datos personales únicamente serán compartidos con nuestros proveedores a fin de poder\n            prestar nuestros servicios, cumpliendo siempre con las medidas de seguridad técnicas y organizativas necesarias.\n          </p>\n          <p>En caso de que los datos sean alojados o tratados fuera de la Unión Europea o el Espacio Económico Europeo,\n            lo haremos siempre garantizando la plena seguridad de estos por medio de mecanismos legales y las medidas de seguridad técnicas oportunas.\n          </p>\n          <p>En Fundeen no cederemos tus datos con otras entidades si no disponemos de tu consentimiento explícito\n            (en cuyo caso lo haríamos únicamente para los fines que nos indiques expresamente), o si es necesario para cumplir con obligaciones legales.\n          </p>\n          <h2>7.MEDIDAS DE SEGURIDAD Y CONSERVACIÓN DE LOS DATOS</h2>\n          <p>Fundeen ha adoptado todas las medidas técnicas y de organización para garantizar la confidencialidad, integridad, disponibilidad y\n            cumplimiento de la regulación, teniendo en cuenta el estado de la técnica y el coste repercutido respecto al riesgo potencial.\n            Además, se compromete a seguir actualizando y mejorando continuamente, a fin de mantener una calidad y seguridad de servicio acorde a lo esperado.\n          </p>\n          <p>Los datos se conservarán durante el tiempo estrictamente necesario para cumplir con las finalidades del tratamiento y cumplir con nuestras obligaciones legales.</p>\n          <p>Tus datos serán conservados hasta el momento de tu baja definitiva como usuario\n            registrado de Fundeen, así como el tiempo necesario para el cumplimiento de nuestras obligaciones legales.\n          </p>\n          <p>En caso de que no seas un usuario registrado, conservamos los datos durante el tiempo necesario\n            para para mantenerte informado y atender tus consultas y peticiones, así como para cumplir con nuestras obligaciones legales.\n          </p>\n          <p>\n            También conservamos información agregada con finalidades estadísticas, asegurándonos que no se pueda\n            identificar a los usuarios registrados, respetando su privacidad.\n          </p>\n          <h2>8. EJERCICIO DE LOS DERECHOS</h2>\n          <p>Podrás ejercer en cualquier momento tus derechos de privacidad y de forma gratuita según establece la normativa aplicable, tales como:</p>\n          <ul>\n              <li>(1)\tConocer qué datos de carácter personal han sido recabados y tratados por Fundeen, para qué finalidades y con qué terceros destinatarios se comparten dichos datos.</li>\n              <li>(2)\tObtener una copia de dichos datos (la segunda y sucesivas copias pueden generar costes administrativos).</li>\n<li>(3)\tSolicitar la rectificación de los datos personales inexactos que te conciernan, o a que se completen aquellos que sean incompletos.</li>\n<li>(4)\tSolicitar la supresión de los datos personales que te conciernan cuando dejen de ser necesarios en relación con los fines para los que fueron recogidos.</li>\n              <li>(5)\tSolicitar la limitación del tratamiento de tus datos personales, en tanto se verifica su potencial inexactitud y demás supuestos previstos en la normativa aplicable.</li>\n              <li>(6)\tEl derecho a que tus datos personales sean transmitidos a otra empresa en un formato común estructurado (derecho a la portabilidad de los datos).</li>\n              <li>(7)\tEl derecho a oponerse al tratamiento de tus datos personales por parte de Fundeen.</li>\n          </ul>\n          <p>Para ejercer cualquiera de estos derechos deberás dirigirte al departamento de privacidad de Fundeen mediante correo electrónico o por correo postal a las\n            direcciones indicadas en el apartado 1 de esta Política. Para poder ejecutar la petición es necesaria la siguiente información:</p>\n          <ul>\n              <li>»\tNombre y apellidos.</li>\n              <li>»\tPetición o derecho que se quiere solicitar.</li>\n              <li>»\tCanal de respuesta. Si no se incluye se responderá por el mismo medio de contacto original.</li>\n              <li>»\tDocumentos acreditativos que sean necesarios.</li>\n          </ul>\n          <p>Fundeen se compromete a tratar todas las peticiones con la mayor celeridad y seguridad posible, en cumplimiento de las leyes aplicables.</p>\n          <p>Fundeen se reserva el derecho de solicitar la documentación necesaria para verificar la identidad del interesado y la legitimidad de la petición.</p>\n          <p>También tienes derecho a presentar una reclamación ante una autoridad de control competente: <a href=\"www.aepd.es\">www.aepd.es</a>.</p>\n          <h2>9.\tVERACIDAD</h2>\n          <p>Es tu responsabilidad proveer datos actuales, correctos y fehacientes a fin de que Fundeen\n            pueda prestar sus servicios. Fundeen te podrá solicitar en cualquier momento los documentos\n             necesarios para comprobar la veracidad de dichos datos y se exime de responsabilidad en caso de que se incumpla tal obligación.</p>\n          <h2>10.\tMODIFICACIONES</h2>\n          <p>Fundeen podrá en cualquier momento revisar y modificar esta Política, bien para adaptarla a la\n             normativa o por recomendaciones de la Agencia Española de Protección de Datos (AEPD). </p>\n          <p>En cualquier caso, se comunicará de forma transparente, y quedará reflejado en esta Política.</p>"'
      this.hasPrivacyText = true;
      this.chdRef.detectChanges();
    });
    this.chdRef.detectChanges();
  }

  async getTermsPolicy() {
    this.profileService.getText('lemonway-terms', this.translate.currentLang).subscribe(value => {
      this.termsTxt = value.content;
      this.hasTermsTxt = true;
      this.chdRef.detectChanges();
    }, error => {
      this.termsTxt = '';
      this.hasTermsTxt = true;
    });
    this.chdRef.detectChanges();
  }

  checkSteps() {
    this.stepNumber = this.list.length;
    this.percent = 100 / this.stepNumber;
    this.currentLang = this.translate.currentLang;
    this.step = 0;
    this.loading = false;
    this.isRegister = false;
    this.acceptConditions = false;
    this.secondBtn = 'secondary-disabled';
    this.getIdBtnName();

    this.device = this.detectOS();

    if (this.isMobileApp !== undefined || (this.device !== 'iOS' && this.device !== 'Android')) {
      this.wantToDownload = false;
    }

    if (this.list[0].name !== 'documentFolder') {
      this.documentCanBack = true;
    } else {
      this.documentCanBack = false;
    }

    if (this.list[0].name === 'code') {
      this.list.unshift({name: 'phoneUser', index: -1});
      this.plusLastStep = 2;
      this.confirmPhoneEvent.emit();
    }

    if (this.profile && this.profile !== undefined && this.profile.mobile && this.profile.mobile !== undefined && this.profile.mobile !== '') {
      this.info.phone = this.profile.mobile;
    }

    if (this.list[0].name === 'emailCode') {
      this.editM = true;
      this.acceptConditions = true;
      this.list.unshift({name: 'emailUser', index: -1});
      this.plusLastStep = 2;
    }

    if (this.editM === null || this.editM === undefined) {
      this.editM = false;
    }

    if (this.info !== undefined && this.info.prefix !== undefined && this.info.prefix !== null && this.info.prefix !== '') {
      let hasPrefix = false;
      this.info.phone = this.info.phone.toString();
      countryPrefix.forEach(element => {
        const prefixN = element.prefix.toString();
        const prefix = this.info.phone.substring(0, prefixN.toString().length);
        if (prefixN === prefix) {
          hasPrefix = true;
        }
      });
      if (!hasPrefix) {
        this.info.prefix = '34';
      }
    } else if (this.info === undefined) {
      this.info.prefix = '34';
    }
    this.list.forEach(element => {
      switch (element.name) {
        case 'emailUser':
          this.emailIndex = element.index;
          this.isRegister = true;
          break;
        case 'docTypeNumber':
          this.idDocumentIndex = element.index;
          break;
        case 'messageFile':
          this.messageIndex = element.index;
          break;
        case 'phoneUser':
          this.phoneIndex = element.index;
          break;
        case 'code':
          this.codeIndex = element.index;
          break;
        case 'emailCode':
          this.emailCodeindex = element.index;
          break;
        case 'nationalityUser':
          this.nationalityIndex = element.index;
          break;
        case 'address':
          this.addressIndex = element.index;
          break;
        case 'downloadApp':
          this.downloadIndex = element.index;
          break;
        case 'nameUser':
          this.generateProfileIndex = element.index;
          break;
        case 'documentFolder':
          this.fileIndex = element.index;
          break;
        case 'accreditedStep':
          this.accreditIndex = element.index;
          break;
        case 'civilStatus':
          this.civilStatusindex = element.index;
          break;
        case 'investMessage':
          this.investMessageIndex = element.index;
          break;
        case 'okInvestFinishMessage':
          this.okInvestMessageIndex = element.index;
          break;
        case 'investFinishMessage':
          this.investFinishMessageIndex = element.index;
          break;
        case 'phoneValidated':
          this.phoneValidatedIndex = element.index;
          break;
        case 'emailValidated':
          this.mailValidatedIndex = element.index;
          break;
        case 'documentOkFile':
          this.documentOkFileIndex = element.index;
          break;
        case 'mangopayCheckStep':
          this.hasToacceptMpTerms = true;
          this.mangopayWalletIndex = element.index;
          break;
        case 'successStep':
          this.successStepIndex = element.index;
          break;
        case 'docNieMsg':
          this.documentNieMsgIndex = element.index;
          break;
        case 'verify_mail':
          this.verifyEmailIndex = element.index;
          break;
        case 'taxdown':
          this.taxdownIndex = element.index;
          break;
      }
    });
    if (this.step !== this.messageIndex) {
      this.sendXHR = 'primaryDark-disabled';
    } else {
      this.sendXHR = 'primaryDark';
    }

    if (this.onlyAccredit && this.onlyAccredit !== undefined) {
      this.lastStep = false;
    } else {
      this.lastStep = true;
    }

    this.chdRef.detectChanges();
  }

  checkMangopayTerms(value) {
    this.mangopayTerms = value;
    if (this.mangopayTerms) {
      this.sendXHR = 'primaryDark';
    } else {
      this.sendXHR = 'primaryDark-disabled';
    }
    this.chdRef.detectChanges();
  }

  lastStepPerson() {
    this.controlProgressBarSize(true);
    this.step++;
    this.chdRef.detectChanges();
  }
  emitDocs(docs) {
    this.emitDocumentsEvent.emit(docs);
    this.chdRef.detectChanges();
  }
  updateDocNumber(model) {
    this.updateDocNumberEvent.emit(model);
    this.controlProgressBarSize(true);
    this.chdRef.detectChanges();
  }
  controlFirstBtn() {
    if (this.acceptConditions && this.info.email && this.info.email !== undefined) {
      this.sendXHR = 'primaryDark';
    } else {
      this.sendXHR = 'primaryDark-disabled';
    }
    this.chdRef.detectChanges();
  }
  controlSecondBtn() {
    if (this.list[this.step - 1]
      && this.list[this.step - 1] !== undefined
      && this.list[this.step - 1].index
      && this.list[this.step - 1].index !== undefined) {
      const prev = this.list[this.step - 1].index;
      if (this.step > 0
        && prev !== this.emailIndex
        && prev !== this.generateProfileIndex
        && prev !== this.codeIndex
        && prev !== this.phoneIndex
        && prev !== this.emailCodeindex) {
        this.secondBtn = 'secondary';
      } else {
        this.secondBtn = 'secondary-disabled';
      }
    } else {
      this.secondBtn = 'secondary-disabled';
    }
  }
  getEmailData(value) {
    this.info.email = value.email;
    this.info.pwd = value.pwd;
    this.controlFirstBtn();
    this.chdRef.detectChanges();
  }
  getNewEmailData(value) {
    if (this.info.email !== value.email || this.info.pwd !== value.pwd) {
      this.info.email = value.email;
      this.info.pwd = value.pwd;
      this.acceptConditions = true;
      this.mailChanged = true;
    } else {
      setTimeout(() => {
        if (!this.mailChanged) {
          this.sendXHR = 'primaryDark';
          this.chdRef.detectChanges();
        }
      }, 500);
    }
    this.controlFirstBtn();
    this.chdRef.detectChanges();
  }
  getConditions(value) {
    this.info.acceptConditions = value;
    this.acceptConditions = value;
    this.controlFirstBtn();
    this.chdRef.detectChanges();
  }
  getDocuments(value) {
    this.controlFirstBtn();
    this.userInfo.document = value;
    this.setDocumentsEvent.emit(value);
  }
  getOffers(value) {
    this.info.acceptOffers = value;
    this.chdRef.detectChanges();
  }
  getPhoneData(value) {
    this.sendXHR = 'primaryDark';
    this.info.mobile = value.pref + value.phone;
    this.info.phone = value.phone;
    this.info.prefix = value.pref;
    this.phoneNumber = value.pref + value.phone;
    this.phoneNumberEvent.emit(this.phoneNumber);
    this.chdRef.detectChanges();
  }
  getError() {
    setTimeout(() => {
      this.sendXHR = 'primaryDark-disabled';
      this.chdRef.detectChanges();
    }, 50);
    this.chdRef.detectChanges();
  }
  public isLoading(value) {
    this.loading = value;
    this.chdRef.detectChanges();
  }
  public sentInfo() {
    this.fullInfoEvent.emit(this.info);
    this.chdRef.detectChanges();
  }
  getCodeInfo(value) {
    if (
      (value.code1 !== null && value.code1 !== '') &&
      (value.code2 !== null && value.code2 !== '') &&
      (value.code3 !== null && value.code3 !== '') &&
      (value.code4 !== null && value.code4 !== '') &&
      (value.code5 !== null && value.code5 !== '') &&
      (value.code6 !== null && value.code6 !== '')
    ) {
      this.sendXHR = 'primaryDark';
      this.info.code =
      value.code1.toString() + value.code2.toString() + value.code3.toString() +
      value.code4.toString() + value.code5.toString() + value.code6.toString();
    } else {
      this.sendXHR = 'primaryDark-disabled';
    }
    this.chdRef.detectChanges();
  }
  getNameInfo(value) {
    this.sendXHR = 'primaryDark';
    this.info.birthDate = value.date ? value.date : value.birthDate;
    this.info.name = value.name;
    this.info.surname = value.surname;
    this.chdRef.detectChanges();
  }
  getNationalityInfo(value) {
    this.sendXHR = 'primaryDark';
    this.info.nation = value.nation;
    this.info.residence = value.residence;
    this.chdRef.detectChanges();
  }
  getDniInfo(value) {
    this.sendXHR = 'primaryDark';
    this.info.docType = value.docType;
    this.info.docNumber = value.dni;
    this.chdRef.detectChanges();
  }

  getAddressInfo(value) {
    this.addressValue = value;
    this.sendXHR = 'primaryDark';
    this.chdRef.detectChanges();
  }

  editMail() {
    this.editM = true;
    this.prev();
    this.sendXHR = 'primaryDark';
    this.chdRef.detectChanges();
  }

  getCivilStatus(value) {
    this.cStatus = Number(value);
    this.sendXHR = 'primaryDark';
    this.chdRef.detectChanges();
  }

  next() {
    if (this.step === this.phoneIndex) {
      this.confirmPhoneEvent.emit();
    }
    if (this.step === this.codeIndex) {
      this.confirmCodeEvent.emit(this.info.code);
    }
    if (this.step === this.emailCodeindex) {
      this.confirmCodeEmailEvent.emit(this.info.code);
    }
    if (this.step === this.generateProfileIndex) {
      this.generateProfileEvent.emit(this.info);
    }
    if (this.step === this.civilStatusindex) {
      const model = {
        civilStatus: this.cStatus
      };
      this.updateInfoEvent.emit(model);
    }
    if (this.step === this.emailIndex) {
      if (!this.editM) {
        const payload = {
          profileType: 1,
          acceptOffers: this.info.acceptOffers || false,
          acceptConditions: this.info.acceptConditions,
          email: this.info.email,
          pwd: this.info.pwd,
          referredPromotionalCode: this.refCode
        };
        this.validateEmailEvent.emit(payload);
        this.getConditions(false);
      } else {
        if (this.mailChanged) {
          const params = {
            email: this.info.email,
            password: this.info.pwd,
          };
          this.changeEmailEvent.emit(params);
        }
      }
    }
    if (this.step === this.nationalityIndex) {
      const model = {
        nationality: Number(this.info.nation),
        taxCountry: Number(this.info.residence),
      };
      this.updateInfoEvent.emit(model);
    }
    if (this.step === this.addressIndex) {
      this.getAddressInfoEvent.emit(this.addressValue);
    }
    if (this.step === this.idDocumentIndex) {
      /*if (this.info.docType !== 1) {
        this.stepNumber = this.stepNumber + 3;
      }*/
      this.emitDocumentEvent.emit(this.info);
    }
    if (this.list.length - this.plusLastStep === this.step) {
      this.lastStepEvent.emit(this.info);
    }
    if (this.step === this.mangopayWalletIndex) {
      this.loading = true;
      this.profileService.updateProfile({ mangopayConditionsAccepted: this.mangopayTerms, acceptPaymentEntity: true }).subscribe(() => {
        this.loading = false;
        this.chdRef.detectChanges();
      },error => {
        if (error.status === 409) {
          this.toastService.showToast(error.error.message, 'warning', true);
          this.list.unshift({name: 'documentFolder', index: 0});
          for (let i = 0; i < this.list.length; i++) {
            this.list[i]['index'] = i;
          }
        } else {
          this.prev();
        }
        this.checkSteps();
        this.loading = false;
        this.chdRef.detectChanges();
      });
    }
    this.step++;
    this.nextEvent.emit(this.step);
    this.controlProgressBarSize(true);
    if (this.step !== this.messageIndex
      && this.step !== this.mailValidatedIndex
      && this.step !== this.phoneValidatedIndex) {
      this.sendXHR = 'primaryDark-disabled';
    }
    if (this.step === this.codeIndex) {
      if (this.wantToDownload) {
        this.timeOutToresend();
      }
    }

    if (this.step >= this.list.length) {
      this.finishProccess();
    }
    this.userInfo.info = this.info;
    this.controlSecondBtn();
    this.getIdBtnName();
    this.chdRef.detectChanges();
  }

  resendCode(value) {
    this.resended = true;
    this.resendCodeEvent.emit(value);
    this.chdRef.detectChanges();
  }

  prev() {
    this.resended = false;
    this.step--;
    if (this.step < 0) {
      if (this.emailCodeindex === 0 || this.codeIndex === 0) {} else {
        this.prevStepEvent.emit();
      }
    }
    if (this.step !== this.messageIndex
      && this.step !== this.mailValidatedIndex
      && this.step !== this.phoneValidatedIndex) {
      this.sendXHR = 'primaryDark-disabled';
    } else {
      this.sendXHR = 'primaryDark';
    }
    this.controlSecondBtn();
    this.prevEvent.emit();
    this.controlProgressBarSize(false);
    this.getIdBtnName();
    this.chdRef.detectChanges();
  }
  openNifInfo() {
    const title = this.translate.instant('register.messages.sure_to_upload');
    const modalParams = {};
    this.actionSheetService.showModal(RegisterPersonNifInfoComponent, modalParams, '', '', true).subscribe((modal: any) => {
      modal.setTitle(title);
      modal.onClose().subscribe();
    });
    this.chdRef.detectChanges();
  }
  changeWay() {
    this.changeWayEvent.emit();
  }
  finishRegister() {
    if (this.step === this.phoneIndex) {
      this.step = this.step + 1;
      this.controlProgressBarSize(true);
      this.otherMomentEventEvent.emit();
    } else if (this.step === this.nationalityIndex) {
      this.step++;
      this.controlProgressBarSize(true);
    } else {
      this.lastStep = true;
      this.step = this.accreditIndex || this.list.length - 1;
      this.percent = (100 / this.stepNumber) * (this.stepNumber - 1);
      this.finishRegisterEvent.emit(this.info);
    }
    this.getIdBtnName();
    this.chdRef.detectChanges();
  }

  continueRegister() {
    this.wantToDownload = false;
    this.chdRef.detectChanges();
  }

  timeOutToresend() {
    this.resended = false;
    this.isCountDowndEnd = false;
    let seconds = 180;
    if (!this.activatedCountDoun) {
      setInterval(() => {
      const minutes = Math.round((seconds - 30) / 60);
      const remainingSeconds = seconds % 60;
      let secondsToEnd;
      let minutesRemaining;
      if (remainingSeconds < 10) {
          secondsToEnd = '0' + remainingSeconds;
      } else {
          secondsToEnd = remainingSeconds;
      }
      if (minutes < 10) {
          minutesRemaining = '0' + minutes;
          if (minutes >= 1) {
          minutesRemaining = '0' + minutes;
          } else {
          minutesRemaining = '';
          }
      } else {
          minutesRemaining = minutes;
      }
      seconds--;
      if (seconds <= 1) {
        this.isCountDowndEnd = true;
        minutesRemaining = '00';
        secondsToEnd = '00';
      }
      if (minutesRemaining >= 1) {
          this.countDown = minutesRemaining + ':' + secondsToEnd;
      } else {
          this.countDown = secondsToEnd;
      }
      if (!this.chdRef['destroyed']) {
        this.chdRef.detectChanges();
      }
    }, 1000);
  }
    this.activatedCountDoun = true;
    this.chdRef.detectChanges();
  }

  public setLastStep() {
    this.step = this.list.length - this.plusLastStep;
    this.chdRef.detectChanges();
  }

  accreditationChecks(value) {
    this.accreditationChecksEvent.emit(value);
    this.chdRef.detectChanges();
  }

  getBankDocument(value) {
    this.bankDocumentEvent.emit(value);
    this.chdRef.detectChanges();
  }

  acceptLw(value) {
    this.controlProgressBarSize(true);
    this.acceptLwTermsEvent.emit(value);
    this.chdRef.detectChanges();
  }

  continueInvest(val?) {
    this.continueInvestEvent.emit(val);
    this.chdRef.detectChanges();
  }

  finishProccess(val?) {
    if (val !== 3) {
      this.finishEvent.emit();
    } else {
      this.loading = true;
      const model = {}
      this.profileService.updateProfile(model).subscribe(prof => {
        this.storage.get('WALLET').then((val) => {
          let wallet = val;
          wallet.walletstatus = prof.walletstatus;
          this.storage.set('WALLET', wallet).then(() => {
            this.profile = prof;
            this.continueInvest(prof);
            this.removeModal();
            this.chdRef.detectChanges();
          });
          this.chdRef.detectChanges();
        });
        this.chdRef.detectChanges();
      });
    }
    this.chdRef.detectChanges();
  }

  accreditedPersonSetLoading() {
    this.registerPersonAccredited.loadingComponent();
    this.chdRef.detectChanges();
  }

  accreditedPersonRemoveLoading() {
    this.registerPersonAccredited.removeLoading();
    this.chdRef.detectChanges();
  }

  async getIdBtnName() {
    let name;

    if (this.list && this.list[this.step] && this.list[this.step].name && this.list[this.step].name !== undefined) {
      name = this.list[this.step].name;
    } else {
      name = '';
    }

    switch (name) {
      case 'emailUser':
        this.personalId = 'pf_sign_up';
        break;
      case 'emailCode':
        this.personalId = 'pf_generic';
        break;
      case 'code':
        this.personalId = 'pf_sms_validation';
        break;
      case 'phoneUser':
        this.personalId = 'pf_mobile_phone';
        break;
      case 'nameUser':
        this.personalId = 'pf_basic_info';
        break;
      case 'nationalityUser':
        this.personalId = 'pf_citizenship';
        break;
      case 'docTypeNumber':
        this.personalId = 'pf_id_number';
        break;
      case 'messageFile':
        this.personalId = 'pf_id_message';
        break;
      default:
        this.personalId = 'pf_register';
    }
    this.chdRef.detectChanges();
  }

  detectOS() {
    const platform = navigator.platform.toLowerCase(), iosPlatforms = ['iphone', 'ipad', 'ipod', 'ipod touch'];
    if (platform.includes('mac')) return 'MacOS';
    if (iosPlatforms.includes(platform)) return 'iOS';
    if (platform.includes('win')) return 'Windows';
    if (/android/.test(navigator.userAgent.toLowerCase())) return 'Android';
    if (/linux/.test(platform)) return 'Linux';
    this.chdRef.detectChanges();
    return 'unknown';
  }

  openAppStore(link) {
    window.open(link);
  }

  getSignaturitUrl() {
    this.signaturitAccreditEvent.emit();
    this.chdRef.detectChanges();
  }

  otherMomentAccredit() {
    this.otherMomentEventEvent.emit();
    this.chdRef.detectChanges();
  }

  fileLoading(value, error?: boolean) {
    this.registerPersonFile.isLoading(value, error);
    this.chdRef.detectChanges();
  }

  public setAccreditSignaturitUrl(url) {
    this.registerPersonAccredited.setSignaturitUrl(url);
    this.chdRef.detectChanges();
  }

  signaturitSigned() {
    this.signaturitSignedEvent.emit();
    this.chdRef.detectChanges();
  }

  controlProgressBarSize(increase) {
    if (increase) {
      this.percent = this.percent + (100 / this.stepNumber);
    } else {
      this.percent = this.percent - (100 / this.stepNumber);
    }
    this.percent = (this.percent <= 100) ? this.percent : 100;
    this.chdRef.detectChanges();
  }

  checkRefCode(code) {
    this.refCode = code;
    this.checkRefCodeEvent.emit(code);
    this.chdRef.detectChanges();
  }

  public setRefUsername(username) {
    this.refCode = username !== undefined ? this.refCode : undefined;
    this.registerPersonEmail.setRefUsername(username);
    this.chdRef.detectChanges();
  }

  showTermsAndConditions(value) {
    this.emailPage = value;
    this.chdRef.detectChanges();
  }

  goToMyProfile(val?) {
    if (val !== 3) {
      this.navCtrl.navigateRoot([this.localize.translateRoute('/my-profile')]);
    }
  }

  removeModal() {
    this.removeModalEvent.emit();
    this.chdRef.detectChanges();
  }

  modifyTaxDownData(data) {
    this.getNameInfo(data);
    this.profile['taxAddress'] = data['taxAddress'];
    this.profile['taxPostalCode'] = data['taxPostalCode'];
    this.profile['docType'] = data['docType'];
    this.info['docType'] = data.docType;
    this.info['docNumber'] = data.identityDocumentDni ? data.identityDocumentDni : data.identityDocumentNie;
    this.info['taxCity'] = data['taxCity'];
    this.info['taxRegion'] = data['taxRegion'];
    this.next();
    this.chdRef.detectChanges();
  }

}
